import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, MapPin, Phone, Mail, Globe, ArrowUp, Facebook, Linkedin, Instagram } from 'lucide-react';
import { company, ourServices, scopeOfWork } from '../mock';
import DeveloperContactCard from './DeveloperContactCard';

const socialLinks = [
  { label: 'Facebook', Icon: Facebook, url: company.social?.facebook },
  { label: 'LinkedIn', Icon: Linkedin, url: company.social?.linkedin },
  { label: 'Instagram', Icon: Instagram, url: company.social?.instagram },
].filter((s) => s.url);

export default function Footer() {
  const [showTop, setShowTop] = useState(false);
  const [showDevCard, setShowDevCard] = useState(false);
  useEffect(() => {
    const on = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', on);
    return () => window.removeEventListener('scroll', on);
  }, []);

  return (
    <>
      <footer className="pt-10 pb-5" style={{ background: 'var(--footer)', color: '#c9c9d5' }}>
        {/* all five column headings sit on one line: Menu | Our Services | Scope of Work | Address | Contact Us.
            Scope of Work gets a wider share of the row so its longer labels wrap less / stay shorter, keeping the footer compact. */}
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[0.85fr_0.95fr_1.35fr_1.05fr_0.9fr] gap-6 lg:gap-5">
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Menu</h4>
            <ul className="space-y-1.5 text-sm">
              {[{n:'Home',t:'/'},{n:'About Us',t:'/about'},{n:'Get Quote',t:'/quote'},{n:'Track Shipment',t:'/track'},{n:'Our Office',t:'/office'},{n:'Contact',t:'/contact'}].map(l => (
                <li key={l.t}><Link to={l.t} className="foot-link flex items-center gap-2"><ChevronRight size={14} /> {l.n}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Our Services</h4>
            <ul className="space-y-1.5 text-sm">
              {ourServices.map((s, i) => (
                <li key={i}><Link to="/services" className="foot-link flex items-center gap-2"><ChevronRight size={14} /> {s.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Scope of Work</h4>
            <ul className="space-y-1.5 text-sm">
              {scopeOfWork.map((s, i) => (
                <li key={i}><Link to="/services" className="foot-link flex items-center gap-2 leading-snug"><ChevronRight size={14} className="shrink-0 mt-0.5" /> <span>{s.name}</span></Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Address</h4>
            <div className="space-y-3 text-sm">
              <div className="flex gap-3"><MapPin size={16} className="mt-1 shrink-0 text-white/70" />
                <div>
                  <div className="text-white/90 font-medium">Head Office:</div>
                  <div>7/33-34, Sharda Sadan,<br/>Near Central Bus Stand, Railway Station Road,<br/>Surat - 395003, Gujarat, India</div>
                </div>
              </div>
              <div className="flex gap-3"><MapPin size={16} className="mt-1 shrink-0 text-white/70" />
                <div>
                  <div className="text-white/90 font-medium">Forwarding Office:</div>
                  <div>34-A/1, Adani Port Road,<br/>Hazira, Choryashi,<br/>Surat - 394270, Gujarat, India</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-3">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <div className="flex gap-3"><Phone size={16} className="mt-1 shrink-0 text-white/70" />
                <div>
                  <div className="text-white/90 font-medium">Phone:</div>
                  <a href={`tel:${company.phoneRaw}`} className="foot-link notranslate">{company.phone}</a>
                </div>
              </div>
              <div className="flex gap-3"><Mail size={16} className="mt-1 shrink-0 text-white/70" />
                <div>
                  <div className="text-white/90 font-medium">Email:</div>
                  <a href={`mailto:${company.email}`} className="foot-link notranslate break-all">{company.email}</a>
                </div>
              </div>
              <div className="flex gap-3"><Globe size={16} className="mt-1 shrink-0 text-white/70" />
                <div>
                  <div className="text-white/90 font-medium">Website:</div>
                  <span className="notranslate break-all">{company.website}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-8 pt-5 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs">
          <div>© {new Date().getFullYear()} VEDYAH EXIM. ALL RIGHTS RESERVED.</div>
          <div className="text-white/60">DEVELOPED BY <span className="text-white/90 font-semibold">PM INFOCOM</span> | <button type="button" onClick={() => setShowDevCard(true)} className="text-white/90 hover:text-white hover:underline transition-colors">AVINASH SUTHAR</button></div>
          {socialLinks.length > 0 && (
            <div className="flex items-center gap-4">
              {socialLinks.map(({ label, Icon, url }) => (
                <a key={label} href={url} target="_blank" rel="noreferrer" aria-label={label} className="hover:text-white transition-colors"><Icon size={16} /></a>
              ))}
            </div>
          )}
        </div>
      </footer>

      <button aria-label="Back to top" className={`to-top ${showTop ? 'show' : ''}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <ArrowUp size={20} />
      </button>

      <DeveloperContactCard open={showDevCard} onClose={() => setShowDevCard(false)} />
    </>
  );
}
